const { createStore } = require('./Store');
const { ReviewReducer } = require('./Reducers');
const { ReviewState } = require('./States');
const { ReviewActions } = require('./Actions');

const [ReviewProvider, useReviewDispatch, useReviewStore] = createStore(
  ReviewReducer,
  ReviewState,
  ReviewActions
);
export { ReviewProvider, useReviewDispatch, useReviewStore };
